export const paymentProcessType = [
  { value: 'Conekta', label: 'Conekta' },
  { value: 'Paypal', label: 'PayPal' },
  { value: 'Tonder', label: 'Tonder' },
  { value: 'Santander', label: 'Santander' },
];

export const settingsConst = {
  exchangeRate: 'Tipo de cambio',
  paymentProcessType: 'Procesador de pago',
  comissionRate: 'Porcentaje de comisión',
  strikeAppointment: 'Limite de cancelación de citas',
  abscenceTime: 'Tiempo de inactividad',
};

export const settingLabel = {
  value: 'Valor',
  setting: 'Configuración',
  options: 'Opciones',
  exchangeRates: 'Ver tipos de cambio',
  strikeAppointment: 'Limite de cancelación de citas',
  abscenceTime: 'Tiempo de inactividad',
};

export const settingOptions = {
  exchangeRate: 'exchangeRate',
  paymentProcessType: 'paymentProcessType',
  comissionRate: 'comissionRate',
  strikeAppointment: 'strikeAppointment',
  abscenceTime: 'abscenceTime',
};
